__turbopack_context__.v({
  "arrow-button": "pagination-module-scss-module__ySlaxq__arrow-button",
  "button-like": "pagination-module-scss-module__ySlaxq__button-like",
  "current-page": "pagination-module-scss-module__ySlaxq__current-page",
  "pagination-container": "pagination-module-scss-module__ySlaxq__pagination-container",
  "placeholder": "pagination-module-scss-module__ySlaxq__placeholder",
});
